import React from 'react';
export function EditorTextBoldIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21V3h7.5C16 3 18 5 18 8c0 2-1.5 3.167-2 3.5 0 0 3 .5 3 4.5s-4 5-6 5H6zm2.5-11V5.5h4c2.5 0 3 1 3 2.5s-1 2-3 2h-4zm0 3v5.5H13c1 0 3-.5 3-2.722S14.5 13 13 13H8.5z"
  }));
}